var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatedit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#F3F3F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.957 23.4564L31.707 13.7064C31.8892 13.5178 31.99 13.2652 31.9877 13.003C31.9854 12.7408 31.8802 12.49 31.6948 12.3046C31.5094 12.1192 31.2586 12.014 30.9964 12.0118C30.7342 12.0095 30.4816 12.1103 30.293 12.2924L20.543 22.0424L20.25 23.7494L21.957 23.4564Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 13C15.5717 13 14.6815 13.3687 14.0251 14.0251C13.3687 14.6815 13 15.5717 13 16.5V27.5C13 28.4283 13.3687 29.3185 14.0251 29.9749C14.6815 30.6313 15.5717 31 16.5 31H27.5C28.4283 31 29.3185 30.6313 29.9749 29.9749C30.6313 29.3185 31 28.4283 31 27.5V20C31 19.7348 30.8946 19.4804 30.7071 19.2929C30.5196 19.1054 30.2652 19 30 19C29.7348 19 29.4804 19.1054 29.2929 19.2929C29.1054 19.4804 29 19.7348 29 20V27.5C29 27.8978 28.842 28.2794 28.5607 28.5607C28.2794 28.842 27.8978 29 27.5 29H16.5C16.1022 29 15.7206 28.842 15.4393 28.5607C15.158 28.2794 15 27.8978 15 27.5V16.5C15 16.1022 15.158 15.7206 15.4393 15.4393C15.7206 15.158 16.1022 15 16.5 15H24C24.2652 15 24.5196 14.8946 24.7071 14.7071C24.8946 14.5196 25 14.2652 25 14C25 13.7348 24.8946 13.4804 24.7071 13.2929C24.5196 13.1054 24.2652 13 24 13H16.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatedit);
export default __webpack_public_path__ + "static/media/chatedit.19ca669bba68fd22dc1fab678c4f6716.svg";
export { ForwardRef as ReactComponent };